import CommonCardModel from "./commonCard.model"
import PosterImageModel from "./posterImage.model"

export default class CollectionCardModel extends CommonCardModel {
    constructor(
        public brand: string | null,
        public canonicalUrl: string,
        public description: string,
        public grades: string[],
        public id: number,
        public posterImages: PosterImageModel[],
        public searchImage: string | null,
        public title: string,
        public resourcesCount: number,
        public type: string = "collection"
    ) {
        super(brand, canonicalUrl, description, grades, posterImages, title, type)
    }

    public static fromData(res) {
        const posterImages: PosterImageModel[] = res.poster_images.map(
            (image: any) => new PosterImageModel(image.type, image.alt_text, image.url)
        )

        return new CollectionCardModel(
            res.brand,
            res.canonical_url,
            res.description,
            res.grades,
            res.id,
            posterImages,
            res.search_image,
            res.title,
            res.resourcesCount
        )
    }
}
